// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1CJnA","modalFooterButton":"ModalNotes_modalFooterButton__1o78k"};